export default "__VITE_ASSET__AvT4Q3cpxMkYTQqTzr1jgQ__"